import React, { Component } from "react";
import { UncontrolledTooltip } from "reactstrap";
import moment from 'moment';
import { type } from "os";
import { fetchData } from "../common/networkRequests";
import CryptoJS from "crypto-js";

import { RelevantIcon } from "./RelevantIcon";
import { domainFunctions } from "./domainFunctions";
import { getAccessors, generateNewRowsToTable } from "../ReportArea/textReport";
import { handlePageChange } from "./ajaxdata";
import * as XLSX from 'xlsx';
import { handleAuditBranchChange } from "../NavbarArea";

import { socketip } from "../../config";

import io from 'socket.io-client';

export const socket = io(`${socketip}`);


const usUnicode = (s) => {
  return /[^\u0000-\u00ff]/.test(s);
}

const getDisplayedTabUID = () => {
  let tab_uids = false;

  let displayed_tabs = document.getElementsByClassName('nav-item');
  if (displayed_tabs) {
    tab_uids = {};
    for (var i = 0; i < displayed_tabs.length; i++) {
      tab_uids[displayed_tabs[i].id] = 1;
    }
  }

  return tab_uids;
}


const getMissingFields = ({ pageData }) => {
  let missing = [];
  let requiredFields = getCookie("requiredFields");
  let tab_uids = getDisplayedTabUID();
  if (requiredFields) {
    requiredFields = JSON.parse(requiredFields);
    for (var key in requiredFields) {
      if (key && key != 'undefined' && requiredFields[key] == 1) {
        if (pageData[key] && pageData[key] != '') {
        } else {
          if (key.indexOf(".") != -1) {
            let tid = key.split(".")[0];
            if (tab_uids[tid] == 1) {
              missing.push(key);
            }
          } else {
            missing.push(key)
          }
        }
      }
    }
  }
  return missing;
}

function detectBrowser() {

  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }
  return browserName;
}


const goToName = (e, next_name, current_name, current) => {


  if (e.key === 'Enter') {
    if (next_name) {
      let ele;
      if (next_name == 'add_to_grid') {
        ele = document.getElementById("add_to_grid_btn");
        ele.click();
        let elem = document.getElementsByTagName('input');
        if (elem[0]) { elem[0].focus(); }

      } else {
        ele = document.getElementsByName(next_name);
        ele = ele[0] ? ele[0] : false;
        if (ele) { ele.focus(); }
      }
    } else {
      let ele = document.getElementsByTagName('input');
      let focus_on_elem;
      let click_on_tab;
      for (var i = 0; i < ele.length; i++) {
        if (current_name == ele[i].name) {
          if (ele[i + 1] && !ele[i + 1].readOnly) {

            focus_on_elem = ele[i + 1];
            let names;
            if (focus_on_elem && !focus_on_elem.name) {
              names = ele[i + 2].name.split(".");
            } else if (focus_on_elem) {
              names = focus_on_elem.name.split(".");
            }
            if (names && names.length > 1) {
              click_on_tab = names[0];
            }
          } else {
            for (var j = i + 1; j < ele.length; j++) {
              console.log({ ele, j, E: ele[j + 1] })
              if (ele[j + 1] && !ele[j + 1].readOnly) {
                focus_on_elem = ele[j + 1];
                let names;
                if (focus_on_elem && !focus_on_elem.name) {
                  names = ele[j + 2].name.split(".");
                } else if (focus_on_elem) {
                  names = focus_on_elem.name.split(".");
                }
                if (names && names.length > 1) {
                  click_on_tab = names[0];
                }
                break;
              }
            }
          }

        }
        // console.log({ E: ele[i], N: ele[i].name });
      }
      if (click_on_tab) {
        let { LocalVars } = current.props.parentState;
        LocalVars['selectedFormTab'] = click_on_tab;
        let x;
        current.props.liftGlobalState({ name: 'LocalVars' }, LocalVars);
        setTimeout(() => { focus_on_elem ? focus_on_elem.focus() : x = 1 }, 100);
      } else {
        if (focus_on_elem) {
          focus_on_elem.focus();
        }
      }
    }
  }
}

const handleLink = ({ url, new_tab, current }) => {
  console.log({ url })

  if (new_tab) {
    let { screen } = current.props.parentState;
    let heights = "height=" + screen.height + ",width=" + screen.width;
    url = 'enc-' + encodeURIComponent(reversibleHash("/" + url));
    let aw = window.open(url, "ORO", 'directories=no,titlebar=no,toolbar=no,' + heights);
    current.props.liftGlobalState({ name: 'directloading' }, true);
    let { LocalVars } = current.props.parentState;

    var t = setInterval(() => {
      if (aw.closed) {
        clearInterval(t);
        current.props.liftGlobalState({ name: 'directloading' }, false);
        if (LocalVars['selectedTourBranch']) {
          let x = JSON.parse(JSON.stringify(LocalVars['selectedTourBranch']));
          x['loadingat'] = new Date();
          handleAuditBranchChange(x, current);
        } else {
          // handleAuditBranchChange(x, current);
        }
      }
    }, 1000);
  } else {
    handlePageChange({ item: { fastpath: url.replace("/", ""), label: "" }, current });
  }
}


const toggleSidebar = (current) => {
  current.props.liftGlobalState(
    { name: "showSidebar" },
    !current.props.parentState.showSidebar
  );
}

const closeSidebar = (current) => {
  current.props.liftGlobalState(
    { name: "showSidebar" }, false
  );
}

const openSidebar = (current) => {
  current.props.liftGlobalState(
    { name: "showSidebar" }, true
  );
}



const replaceVariablesWithValue = (str = "", data) => {
  str = str.trim();
  let newString = str;
  var regExp = /\{([^}]+)\}/g;
  // var regExp = /\(([^)]+)\)/g;
  let allMatches = str.match(regExp);
  allMatches && allMatches.map(m => {
    let mtch = m.replace("}", "").replace("{", "");
    newString = newString.replace(m, data[mtch]);
  });

  return newString;
}


const getValueFromCondition = (expr, row) => {
  // (total)==(success) ? icon-tick : (success)==0 ? icon-cross : (success)/(total)
  let [condition, valueString] = expr.split("?");
  let success = false;
  let comparators = ["==", ">=", "<=", ">", "<", "!="];
  let matched = false;
  let value = false;
  comparators.map(c => {
    if (!matched && condition.indexOf(c) != -1) {
      let v = condition.split(c);
      let val1 = replaceVariablesWithValue(v[0], row);
      let val2 = replaceVariablesWithValue(v[1], row);
      if (c == '==') {
        if (String(val1) == String(val2)) {
          value = replaceVariablesWithValue(valueString, row);
          matched = true;
        }
      } else if (c == '>=') {
        if (val1 >= val2) {
          value = replaceVariablesWithValue(valueString, row);
          matched = true;
        }
      } else if (c == '<=') {
        if (val1 <= val2) {
          value = replaceVariablesWithValue(valueString, row);
          matched = true;
        }
      }
      else if (c == '>') {
        if (val1 > val2) {
          value = replaceVariablesWithValue(valueString, row);
          matched = true;
        }
      }
      else if (c == '<') {
        if (val1 < val2) {
          value = replaceVariablesWithValue(valueString, row);
          matched = true;
        }
      }
      else if (c == '!=') {
        if (val1 != val2) {
          value = replaceVariablesWithValue(valueString, row);
          matched = true;
        }
      }
    }
  })

  return { success: matched, value };
}



const getResultFromCondition = (display_field, row) => {
  let res = false;
  let conditionSuccess = false;
  if (display_field) {
    if (display_field.indexOf('{') != -1) {
      let conditions = display_field.split(":");
      for (var j = 0; j < conditions.length; j++) {
        let condition = conditions[j];
        if (condition.indexOf('?') != -1) {
          let conditionResult = getValueFromCondition(condition, row);
          if (conditionResult.success) {
            conditionSuccess = true;
            res = conditionResult.value;
          }
        } else {
          if (!conditionSuccess) {
            res = replaceVariablesWithValue(condition, row);
          }
        }
      }
    } else {
      res = row[display_field]
    }
  }

  return res;
}



const checkIfFastpathAllowed = async ({ searched, current }) => {
  let { remoteip } = current.props.parentState

  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let method = 'post';
  let allSidbarsearch = { searched, dataType: "sidebarsearch" };
  let response = await fetchData({ url, postData: allSidbarsearch, method, current });
  return response;
}


const normalizeDisplayData = ({ ReportsData, extraRows = {} }) => {
  let flatData = [];
  for (var key in ReportsData) {
    if (extraRows.location == "top") {
      flatData.push(ReportsData[key]);
    }
    if (ReportsData[key].subRows) {
      flatData = flatData.concat(normalizeDisplayData({ ReportsData: ReportsData[key].subRows, extraRows }))
    }
    if (!extraRows.location || extraRows.location == "bottom") {
      flatData.push(ReportsData[key]);
    }
  }
  return flatData;
}

const simple_csv_download = ({ rows, filename, filetype = 'xls' }) => {
  let exportdata = [];
  rows.map(row => exportdata.push(row.join(",")));
  exportdata = exportdata.join("\n");
  var hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:attachment/text;charset=utf-8,%EF%BB%BF' + encodeURI(exportdata);
  hiddenElement.target = '_blank';
  hiddenElement.download = filename + "." + filetype;
  hiddenElement.click();
  return exportdata;
}



function s2ab(s) {
  var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  var view = new Uint8Array(buf);  //create uint8array as viewer
  for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
  return buf;
}


const download_xlsx = ({ ReportsData, history, shownColumns, extraRows }) => {

  let printData = normalizeDisplayData({ ReportsData, extraRows });
  let { reportHeader } = history;

  var fileName = reportHeader + '.xlsx';
  let alldata = [];
  let ed = [];
  for (var i = 0; i < shownColumns.length; i++) {
    ed.push(shownColumns[i].Header);
  }
  alldata.push(ed);
  for (var j = 0; j < printData.length; j++) {
    let ed = [];
    for (var i = 0; i < shownColumns.length; i++) {
      let val = printData[j][shownColumns[i].accessor];
      if (shownColumns[i].type == 'tick') {
        val = val.props.icon == 'cross' ? "NO" : "YES"
      }
      ed.push(val);
    }
    alldata.push(ed);
  }

  var worksheet = XLSX.utils.aoa_to_sheet(alldata);

  var workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dates");

  XLSX.writeFile(workbook, fileName);

}


const startFaviconSpin = () => {
  var link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = '/images/favicon/inprogress.png';
  // link.type = 'image/gif';

}

const stopFaviconSpin = () => {
  var link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = '/images/favicon/oro-logo.png';
  // link.type = 'image/png';
}

const download_csv = ({ ReportsData, history, shownColumns, extraRows }) => {
  let printData = normalizeDisplayData({ ReportsData, extraRows });
  let { reportHeader, csvprops } = history;

  let exportdata = "";
  let ed = [];
  for (var i = 0; i < shownColumns.length; i++) {
    ed.push(shownColumns[i].Header);
  }
  if (csvprops && csvprops.quotes) {
    exportdata += '"' + ed.join('","') + '"\n';
  } else {
    exportdata += ed.join(',') + '\n';
  }

  for (var j = 0; j < printData.length; j++) {
    let ed = [];

    for (var i = 0; i < shownColumns.length; i++) {
      ed.push(printData[j][shownColumns[i].accessor]);
    }
    if (csvprops && csvprops.quotes) {
      exportdata += '"' + ed.join('","') + '"\n';
    } else {
      exportdata += ed.join(',') + '\n';
    }
  }

  var hiddenElement = document.createElement('a');
  hiddenElement.href = 'data:attachment/text,' + encodeURI(exportdata);
  hiddenElement.target = '_blank';
  hiddenElement.download = reportHeader + ".csv";
  hiddenElement.click();
}

const checkAccessRights = (profile, fastpath) => {
  let allowed = true;
  // for (var i in profile.roles) {
  //   let roledef = profile.roles[i];
  //   for (var j in roledef.limits) {
  //     let limit = roledef.limits[j];
  //     if (fastpath == limit.form_code) {
  //       allowed = true;
  //     }
  //   }
  // }
  // if (!allowed) {
  //   for (var i in profile.limits) {
  //     let limit = profile.roles[i];
  //     if (fastpath == limit.form_code) {
  //       allowed = true;
  //     }
  //   }
  // }

  return allowed;
}

const getObjectsObject = (obj, value) => {
  value.split(".").map(k => ((obj[k] || obj[k] == 0) ? (obj = obj[k]) : (obj = {})));
  return obj;
};

const getObjectsValue = (obj, value, isparent = false) => {
  if (isparent) {
    return obj[value];
  }
  else {
    value.split(".").map(k => ((obj[k] || obj[k] == 0) ? (obj = obj[k]) : (obj = {})));
  }
  return (typeof obj !== "object" || obj instanceof Array) ? obj : "";
};


// stringMaker({orig:"Tiral Balance $as_on$ for branch $branch$", data:{as_on:'today',branch:'pune'}});
const stringMaker = ({ orig, data }) => {
  let matches = orig.match(/\$.*?\$/g);
  matches.map(mat => {
    let varname = mat.replace(/\$/g, '');
    let re = new RegExp("\\$" + varname + "\\$", 'g');
    let varvalue = getObjectsObject(data, varname);
    if (varname.indexOf('date') != -1) {
      varvalue = moment(varvalue).format("DDMMYY");
    }
    orig = orig.replace(re, varvalue);
  })
  return orig;
}




const unsetAllPopovers = () => {
  let allActive = document.getElementsByClassName("custom-popover");
  if (allActive) {
    Array.from(allActive).forEach((act) => {
      act.style.visibility = "hidden";
    });
  }
}


const handleToggleColumn = (accessor, isChecked, current) => {

  let { currentPage, LocalVars, formElements } = current.props.parentState;
  let { hiddenColumns } = LocalVars;
  hiddenColumns[accessor] = isChecked;

  LocalVars["forceRender"] = "test";
  current.props.liftGlobalState({ name: "LocalVars" }, LocalVars);

  // update show values in  displayColumns.
  let { displayColumns } = formElements[currentPage]["history"];
  toggleColumnValue(displayColumns, accessor, isChecked);
};

const toggleColumnValue = (displayColumns, accessor, value) => {
  for (var i = 0; i < displayColumns.length; i++) {
    if (displayColumns[i].columns) {
      toggleColumnValue(displayColumns[i].columns, accessor, value);
    } else {
      if (displayColumns[i].accessor == accessor) {
        displayColumns[i].show = !value;
      }
    }
  }
}



const handleLogout = async (current) => {
  // setCookie("orosession", "");
  deleteAllCookies();

  if (current) {
    current.props.liftGlobalState({ name: "showProfile" }, false);
    let lgs = current.props.liftGlobalState;
    // push to alerts
    let { notifications, LocalVars, remoteip } = current.props.parentState;

    let { token, user_code } = current.props.parentProps.parentState;
    let allLoginData = { token, dataType: 'logout', LoginID: user_code };

    // console.log(allLoginData)
    // let result = await request1(allLoginData);
    let CBSurl = `${remoteip}/sentry`;
    let url = CBSurl;
    let method = 'post';

    fetchData({ url, postData: allLoginData, method, headers: { Authorization: `JWT ${current.props.parentProps.parentState.token}` } });

    notifications = { value: "Logging Out. Please Wait. . . ", notificationType: "warning" };
    lgs({ name: 'notifications' }, notifications);

    // // Gives error
    // try {
    //   current.props.liftWrapperState({ name: "authenticated" }, false);
    // }
    // catch (e) {

    // }
    // lgs({ name: "currentPage" }, "login");

    //eslint-disable-next-line
    // history.pushState(null, '', '/login');

    // fetchData({ url, postData: allLoginData, method, headers: { Authorization: `JWT ${current.props.parentProps.parentState.token}` } });
  }

  setTimeout(() => {
    window.location = "/login";
  }, 500)
}




const getReportColumns = (displayColumns = [], currentColumns = []) => {
  for (var i = 0; i < displayColumns.length; i++) {
    if (displayColumns[i].columns) {
      getReportColumns(displayColumns[i].columns, currentColumns);
    } else {
      currentColumns.push(displayColumns[i]);
    }
  }
  return currentColumns;
}

const reversibleHash = (plain, sec = '14115682-a9a4-4b9b-94f6-a47fd6dc87a7') => {
  const ciphertext = CryptoJS.AES.encrypt(plain, sec).toString();
  return ciphertext;
}

const reverseHash = (encrypted, sec = '14115682-a9a4-4b9b-94f6-a47fd6dc87a7') => {
  let decrypted = CryptoJS.AES.decrypt(encrypted, sec).toString(CryptoJS.enc.Utf8);
  return decrypted;
}

function convertCurrency(val, rate) {
  let final = val;
  if (!isNaN(parseFloat(val)) && rate) {
    let definition = { Rupees: 1, Thousands: 1000, Lakhs: 100000, Crores: 10000000, Millions: 1000000, Billions: 1000000000 };
    if (!rate) { rate = 'Rupees'; }
    if (definition[rate]) {
      final = (parseFloat(val) / (definition[rate] * 1.00)).toFixed(2);
      // final = currencyCommas(conv);
    }
  }
  return currencyCommas(final);
}

function convertTableValueFormat(totalDis, rate, displaytype) {
  let boxvalue;
  if (displaytype == 'currency') {
    boxvalue = convertCurrency(totalDis, rate)
  }
  else if (displaytype == 'masked') {
    if (totalDis) {
      boxvalue = 'XXXX' + totalDis.substr(totalDis.length - 4, totalDis.length);
    }
  }
  else if (displaytype == 'date') {
    boxvalue = totalDis ? toDate(totalDis) : "";
  }
  else if (displaytype == 'datetime') {
    boxvalue = totalDis ? toDateTime(totalDis) : "";
  }
  else if (displaytype == 'uppercase') {
    boxvalue = totalDis ? totalDis.toUpperCase() : totalDis;
  }
  else if (displaytype == 'small') {
    boxvalue = totalDis ? totalDis.toLowerCase() : totalDis;
  }
  else if (displaytype == 'sentencecase') {
    boxvalue = totalDis ? sentenceCase(totalDis) : totalDis;
  } else if (displaytype == 'titlecase') {
    boxvalue = totalDis ? toTitleCase(totalDis) : totalDis;
  } else if (displaytype == 'camelcase') {
    boxvalue = totalDis ? camelCase(totalDis) : totalDis;
  }
  else if (displaytype == 'url') {
    if (totalDis) {
      boxvalue = <span style={{ textDecoration: "underline", color: "blue" }} onClick={() => window.open(totalDis, '_blank')}>Download</span>
    }
  }
  else if (displaytype == 'yesno') {
    boxvalue = (totalDis && totalDis != "") ? "YES" : "NO";
  } else if (displaytype == 'tick') {
    boxvalue = (totalDis && totalDis != "") ? <RelevantIcon icon="tick" style={{ verticalAlign: "middle", borderColor: "black", color: "#2C3644" }} /> : <RelevantIcon icon="cross" style={{ verticalAlign: "middle", borderColor: "black", color: "#2C3644" }} />;
  }
  else if (displaytype == 'image') {
    boxvalue = totalDis ? <img src={`https://localhost:7378/file/${totalDis}`} /> : "";
  }

  return boxvalue;
}



function combineMultiQData(allData) {
  return allData[0];
}


const toAngle = (deg) => {
  let htmlrad = deg * Math.PI / 180.0;
  return htmlrad;
}

const groupServerData = ({ serverData, history, current }) => {
  let { pageData, clickedSlice, clickedSliceLast } = current.props.parentState;
  let rate = pageData.currency_convert;
  let x;

  if (clickedSliceLast || clickedSliceLast != '0') {
    clickedSlice = clickedSlice + "_" + clickedSliceLast;
  }

  var { displayColumns, defaultsTo } = history;
  let accessors = getAccessors({ displayColumns, type: 'all' });

  let serverDataList;
  if (serverData && !(serverData[0] instanceof Array)) {
    serverDataList = [serverData];
  } else {
    serverDataList = serverData ? serverData : [];
  }

  let allData = [];
  for (var j = 0; j < serverDataList.length; j++) {
    let od = [];
    let cleanqdata = [];
    let qdata = serverDataList[j];
    for (var i in qdata) {
      od.push({ ...qdata[i] });
    }

    // Calculate totals, subtotals counts etc. 
    // insert calculated rows in od 
    if (history.extraRows) {
      od = generateNewRowsToTable({ tableData: od, extraRows: history.extraRows });
    }

    // run formulae and apply styles.
    od.map((row, idx) => {
      let r = applyColumnStyleToReport({ row, accessors, current, idx, rate });
      if (accessors.srno && !r['srno'] && r['level'] == 1) {
        r.srno = idx + 1
      }
      cleanqdata.push(r);
    });

    allData.push(cleanqdata);
  }
  let combinedData = combineMultiQData(allData);

  if (clickedSlice) {
    let ps = clickedSlice.replace("grp_", '').split('_');
    ps.map((level, idx) => {
      // console.log({ level, idx });
      try {
        if (idx > 0) {
          combinedData = combinedData[0].subRows[level];
        } else {
          combinedData = [combinedData[level]];
        }
      }
      catch (e) {
      }
    })
    if (!(combinedData instanceof Array)) {
      combinedData = [combinedData];
    }
  }

  let finalData;
  if (defaultsTo || defaultsTo == 0) {
    finalData = combinedData.map(cd => {
      let row = {};
      for (var key in cd) {
        row[key] = (!cd[key] && cd[key] != 0) ? defaultsTo : cd[key];
      }
      return row;
    })
  }


  return finalData ? finalData : combinedData;
}

const setStyleToColumns = (displayColumns) => {
  let converted = [];
  for (var key in displayColumns) {
    let c = displayColumns[key];
    if (c.accessor) {
      let { fontWeight, align, back, color, formula } = c;
      let styles = c.style ? c.style : {};
      styles.fontSize = 14;
      if (formula) { styles['fontWeight'] = 'bold'; }
      if (c.type == 'currency') { styles['textAlign'] = 'right'; }
      if (c.type == 'tick') { styles['textAlign'] = 'center'; }
      if (align) { styles['textAlign'] = align; }

      if (fontWeight) { styles['fontWeight'] = "bold"; }
      if (back) { styles['backgroundColor'] = back; }
      if (color) { styles['color'] = color; }

      // if (!c.width) { c.width = 'auto'; }
      c.Cell = row => <div style={styles}>{row.value}</div>;
      converted.push(c);
    } else {
      let n = {};
      n.hide = c.hide;
      n.Header = c.Header;
      n.columns = setStyleToColumns(c.columns);
      n.width = c.width ? c.width : 'auto';
      converted.push(n);
    }
  }
  return converted;
}

const applyColumnStyleToReport = ({ row, accessors, current, idx, rate }) => {
  let { parentState } = current.props;

  let r = {};
  if (row.skip_rows) { r['main_col'] = row.main_col; r['skip_rows'] = row.skip_rows; }
  if (row.level) { r['level'] = row.level; }
  if (row.row_id != undefined) { r['row_id'] = row.row_id; }
  if (row.subRows) { r['subRows'] = row.subRows; }
  r['unique_id'] = row.unique_id ? row.unique_id : row.uid;
  if (row.subRows) {
    r.subRows = []
    row.subRows.map((subrow, idx) => {
      r.subRows.push(applyColumnStyleToReport({ row: subrow, accessors, current, idx, rate }));
    });
  }

  for (var field in accessors) {
    if (accessors[field].valtype == 'f') { // Run the formula  
      let allResults = {};
      let final;
      accessors[field].formula.map(func => {
        let { calcType, inputs, resultVar } = func;
        final = domainFunctions[func.f]({ parentState, calcType, inputs, allResults, current, fixed: row });
        allResults[resultVar] = final;
      });
      r[field] = final;
    } else {
      r[field] = row[field];
    }
    if (accessors[field].type && accessors[field].type == 'autoinc') {
      if (!row.skip_rows) {
        r[field] = idx + 1;
      } else {
        r[field] = ''; // give custom header as per the page/ pdf or text
      }
    }
    else if (accessors[field] && accessors[field].type) {
      if (accessors[field].type) {
        let x = r[field];
        if ((!row.skip_rows) || (row.skip_rows && accessors[field].type != 'tick')) {
          r[field] = convertTableValueFormat(r[field], rate, accessors[field].type)
          if (accessors[field].type == 'tick') {
            r[field + "_original"] = x;
          }
        }
      }
    }
  }
  return r;
}

const isObjBlank = ({ obj }) => {
  // console.log(obj)
  // loop through VALUES. If ALL are blank THEN ONLY true, else false.
  for (var key in obj) {
    if (obj[key] !== null && obj[key] != "")
      return false;
  }
  return true;
}

export const showFilter = ({ current, act }) => {
  let { LocalVars } = current.props.parentState;
  LocalVars["showFilter"] = act == 'hide' ? false : true;
  LocalVars["ShowHistory"] = act == 'hide' ? false : true;
  current.props.liftGlobalState(
    { name: "ShowSidebar" },
    false
  );
  current.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  current.props.liftGlobalState({ name: "pageData" }, {});
}

const toggleFullReport = ({ current }) => {
  let { full_report } = current.props.parentState;
  current.props.liftGlobalState({ name: "full_report" }, !full_report);
}

const handleFilter = ({ current, act }) => {
  let moveaway = true;
  let { pageData, LocalVars } = current.props.parentState;
  if (act == 'hide') {
    LocalVars['selectedFormTab'] = "";
    current.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  }

  if (pageData && isObjBlank({ obj: pageData }) == false && act == 'show') {
    moveaway = window.confirm("Do you want to move away from the page? All the unsaved changes will be lost!");
  }
  if (moveaway) {
    showFilter({ current, act });
    current.props.liftGlobalState({ name: 'errorMessages' }, {});
    current.props.liftGlobalState({ name: 'notifications' }, {});
    if (!current.props.parentProps.parentState.identi) {
      openSidebar(current);
    }
  }
};

const mobileNumber = /^[0-9]{10}$/;
const panCardNumber = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
const validEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const adharNumber = /^\d{4}\d{4}\d{4}$/g;

function removeElementFromArray({ arr, elem }) {
  return arr.slice(0, arr.indexOf(elem)).concat(arr.slice(arr.indexOf(elem) + 1))
}



function padding({ typed, direction, padWith, len }) {
  if (!direction) { direction = 'left' }
  if (!padWith) { padWith = '0' }
  let leftpad = 0;
  let rightpad = 0;
  if (direction == 'left') {
    leftpad = Math.max(len - typed.length, 0);
  } else {
    rightpad = Math.max(len - typed.length, 0);
  }
  let final = padWith.repeat(leftpad) + typed + padWith.repeat(rightpad);
  return final;
}

const calculateInterest = async ({ current, retval, intOnly }) => {
  let { remoteip, pageData } = current.props.parentState;
  // let remoteip2="secretIP";
  let CBSurl = `${remoteip}/sentry`;
  let url = CBSurl;
  let dov;
  let closing_charges = pageData.entered_charges;
  if (!retval) {
    dov = {
      product_type_guid: pageData.product_type_guid,
      account_number_guid: pageData.account_number_guid
    };
  } else {
    dov = {
      product_type_guid: retval.product_type_guid,
      account_number_guid: retval.guid
    };
  }

  let pd = {
    dataType: "closeAc",
    dependantOnValues: dov,
    currentPage: current.props.component.name
  }
  let { results, exceptions, error } = await fetchData({ url, postData: pd, method: "post", headers: { Authorization: `JWT ${current.props.parentProps.parentState.token}` } });

  current.props.liftState({ name: 'amountReadOnly' }, true);
  current.props.liftState({ name: 'payable_interest' }, results.intcalc);
  if (intOnly) {
    current.props.liftState({ name: 'entered_amount' }, results.intcalc);
  } else {
    let prinbal = retval ? retval.balance : pageData.balance;
    let amt = prinbal + results.intcalc - (closing_charges ? closing_charges : 0);
    current.props.liftState({ name: 'entered_amount' }, amt);
    current.props.liftState({ name: 'total_explanation' }, `Principal Balance =  ${prinbal}\nInterest = ${results.intcalc}\nCharges = ${closing_charges}\nTotal = ${amt}`);
  }
}

function number2text(value) {
  // console.log(value)
  var fraction = Math.round(frac(value) * 100);
  var f_text = "";

  if (fraction > 0) {
    f_text = "AND " + convert_number(fraction) + " PAISE";
  }
  // console.log(value.length)
  let result
  if (value && String(value).length > 0) {
    // console.log(value)
    result = convert_number(value) + " RUPEES " + f_text + " ONLY";
  } else {
    result = ""
  }
  // console.log(result)
  return result
}

function frac(f) {
  return f % 1;
}

function convert_number(number) {
  let tempnum = number;
  if (number < 0 || number > 99999999999999) {
    return "NUMBER OUT OF RANGE!";
  }
  var Gn = Math.floor(number / 10000000); /* Crore */
  number -= Gn * 10000000;
  var kn = Math.floor(number / 100000); /* lakhs */
  number -= kn * 100000;
  var Hn = Math.floor(number / 1000); /* thousand */
  number -= Hn * 1000;
  var Dn = Math.floor(number / 100); /* Tens (deca) */
  number = number % 100; /* Ones */
  var tn = Math.floor(number / 10);
  var one = Math.floor(number % 10);
  var res = "";

  if (Gn > 0) {
    res += convert_number(Gn) + " CRORE";
  }
  if (kn > 0) {
    res += (res == "" ? "" : " ") + convert_number(kn) + " LAKH";
  }
  if (Hn > 0) {
    res += (res == "" ? "" : " ") + convert_number(Hn) + " THOUSAND";
  }

  if (Dn) {
    res += (res == "" ? "" : " ") + convert_number(Dn) + " HUNDRED";
  }

  var ones = Array(
    "",
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
    "FIVE",
    "SIX",
    "SEVEN",
    "EIGHT",
    "NINE",
    "TEN",
    "ELEVEN",
    "TWELVE",
    "THIRTEEN",
    "FOURTEEN",
    "FIFTEEN",
    "SIXTEEN",
    "SEVENTEEN",
    "EIGHTEEN",
    "NINETEEN"
  );
  var tens = Array(
    "",
    "",
    "TWENTY",
    "THIRTY",
    "FOURTY",
    "FIFTY",
    "SIXTY",
    "SEVENTY",
    "EIGHTY",
    "NINETY"
  );

  if (tn > 0 || one > 0) {
    if (!(res == "")) {
      res += " AND ";
    }
    if (tn < 2) {
      res += ones[tn * 10 + one];
    } else {
      res += tens[tn];
      if (one > 0) {
        res += "-" + ones[one];
      }
    }
  }
  if (tempnum == 0) {
    res = "Zero";
  } else if (res == "") {
    res = "";
  }
  return res;
}

const pageDefinitionPerName = (elements, filter) => {
  let elems; let op = {};
  if (filter && filter === true) {
    elems = elements['filter'];
  }
  else if (filter == 'direct') {
    elems = elements;
  }
  else { elems = elements['form']; }
  for (var i = 0; i < elems.length; i++) {
    if (elems[i].name) {
      op[elems[i].name] = elems[i];
    } else if (elems[i].subComponents) {
      let ll = pageDefinitionPerName(elems[i].subComponents, 'direct');
      for (var k in ll) {
        op[k] = ll[k];
      }
    }
  }
  return op;
}

const forceClearData = ({ datas, clearData, formElements, currentPage, showFilter }) => {
  let defs = pageDefinitionPerName(formElements[currentPage], showFilter); // name:{definition}

  for (var i = 0; i < clearData.length; i++) {
    if (defs[clearData[i]]) {
      datas.keys.push({ "name": clearData[i] });
      datas.values.push('');
      let displayDataOther = defs[clearData[i]].displayData;
      let clearDataOther = defs[clearData[i]].clearData;
      if (displayDataOther) {
        datas = clearDisplayData({ datas, displayData: displayDataOther, name: '' });
      }
      if (clearDataOther) {
        datas = forceClearData({ datas, clearData: clearDataOther, formElements, currentPage, showFilter });
      }
    } else {
      datas.keys.push({ "name": clearData[i] });
      datas.values.push('');
      if (clearData[i].indexOf("_code")) {
        datas.keys.push({ "name": clearData[i].replace("_code", '_display') });
        datas.values.push('');
        datas.keys.push({ "name": clearData[i].replace("_code", '_uid') });
        datas.values.push('');
      }
    }
  }
  return datas;
}


// No need to find the displaydata of the other fields, as they will be precisely defined here.
const clearDisplayData = ({ datas = { keys: [], values: [] }, displayData, name }) => {
  for (var key in displayData) {
    let skip = false;
    let fieldName = displayData[key];
    if (displayData[key].field) {
      fieldName = displayData[key].field;
      if (displayData[key].skip) {
        skip = true;
      }
    }
    if (!skip) {
      if (name != fieldName) {
        datas.keys.push({ "name": fieldName });
        datas.values.push('');
      }
    }
  }
  return datas;
}

function deleteAllCookies() {
  localStorage.clear();
}

function deleteAllRealCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}


function setRealCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  cvalue = reversibleHash(cvalue);
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getRealCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      let val = c.substring(name.length, c.length);
      val = reverseHash(val);
      return val;
    }
  }
  return "";
}


function setCookie(cname, cvalue, exdays) {
  localStorage.setItem(cname, cvalue);
}

function getCookie(cname) {
  var sessionItem = localStorage.getItem(cname);
  return sessionItem;
}

const generateOtherValues = (sendData, pageData) => {
  // let { pageData, openmodals } = this.props.parentState;
  // console.log(sendData)
  let returnVal = {}
  if (sendData.length != 0) {
    sendData.map(otherfield => {
      // console.log(typeof pageData)
      if (otherfield.varname) {
        returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
      } else {
        returnVal[otherfield] = getObjectsValue(pageData, otherfield);
      }
    })
  }
  // console.log(returnVal)
  return returnVal
}



function currencyCommas(val) {
  let rupees, paise, res;
  if (val) {
    [rupees, paise] = String(val).split(".");
    res = rupees.toString().replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    if (paise) {
      res += "." + padding({ typed: paise, direction: "right", padWith: "0", len: 2 })
    } else {
      res += ".00";
    }
  } else {
    res = '0.00';
  }
  return res;
}



function currencyNonCommas(val) {
  let rupees, paise, res;
  if (val) {
    [rupees, paise] = String(val).split(".");
    res = rupees;
    if (paise) {
      res += "." + padding({ typed: paise, direction: "right", padWith: "0", len: 2 })
    } else {
      res += ".00";
    }
  } else {
    res = '0.00';
  }
  return res;
}


const shouldDisplayComponent = ({ current, pageData, component, allData }) => {

  let finalRender = { shouldRender: 0, conditionalRender: "no" };

  if (component.parents) {
    let allParents;
    if (component.parents[0] instanceof Array) {
      allParents = component.parents;
    } else {
      allParents = [component.parents];
    }
    for (let k = 0; k < allParents.length; k++) {
      let shouldRender = 1;
      let conditionalRender = 'no';
      let p = allParents[k];
      for (let i = 0; i < p.length; i++) {
        let elem = p[i];
        let parentVal;

        let pd = pageData;
        if (elem.source == 'appwrapper') {
          pd = current.props.parentProps.parentState;
        } else if (elem.source == 'app') {
          pd = current.props.parentState;
        }
        if (typeof (elem.name) == 'string') {
          parentVal = getObjectsValue(pd, elem.name, true);
        }

        if (elem.match == "equal") { // gt & lt
          let isequal = false;
          let noblank = true;
          isequal = elem.name.every(el => {
            if (!getObjectsValue(pd, el)) { noblank = false; }
            return getObjectsValue(pd, el) == getObjectsValue(pd, elem.name[0])
          });
          if (elem.reverse) {
            shouldRender = (isequal || !noblank) ? 0 : 1;
          } else {
            shouldRender = (isequal && noblank) ? 1 : 0;
          }
        }
        else if (
          elem.reverse &&
          ((elem.match === "exist" && parentVal) ||
            (elem.match === "in" && elem.value.indexOf(parentVal) != -1) ||
            (elem.match === "value" && parentVal == elem.value))
        ) {
          shouldRender = 0;
        } else if (
          !elem.reverse &&
          ((elem.match === "exist" && parentVal) ||
            (elem.match === "value" && parentVal == elem.value))
        ) {
          shouldRender = shouldRender * 1;
        } else if (
          !elem.reverse &&
          ((elem.match === "exist" && parentVal) ||
            (elem.match === "in" &&
              elem.value.indexOf(parentVal) != -1))
        ) {
          shouldRender = shouldRender * 1;
        } else {
          if (!elem.reverse) {
            shouldRender = 0;
          }
        }

        if (shouldRender == 0 && elem.show && (elem.show == 'blank' || elem.show == 'readonly')) {
          shouldRender = 1;
          conditionalRender = elem.show;
        }
      }

      if (finalRender['shouldRender'] == 1) {
        if (finalRender['conditionalRender'] != "no" && (conditionalRender == 'readonly' || conditionalRender == 'no')) {
          finalRender['conditionalRender'] = conditionalRender;
        }
      } else {
        finalRender['shouldRender'] = shouldRender;
        finalRender['conditionalRender'] = conditionalRender;
      }
    }
  } else {
    finalRender = { shouldRender: 1, conditionalRender: "no" };
  }


  return { shouldRender: finalRender['shouldRender'], conditionalRender: finalRender['conditionalRender'] };
};

function getMomentDiff(converted) {
  let currentage
  if (converted) {
    let diffnum = moment(converted).diff(moment(), 'milliseconds');
    let diff = moment.duration(diffnum);
    let inText = " From Now";
    if (diffnum < 0) {
      inText = " Ago";
    }
    currentage = (diff.years() != 0 ? Math.abs(diff.years()) + " Years, " : "") + (diff.months() != 0 ? Math.abs(diff.months()) + " Months, " : "") + (diff.days() != 0 ? Math.abs(diff.days()) + " Days" : "") + inText;
  } else {
    currentage = ""
  }

  return currentage;
}

function statusErrorDisplay(row) {
  let completedPercentage = 0;
  if (row.original && row.original.queries) {
    completedPercentage = String(
      Number(
        (100 * row.original.queries.done) / row.original.queries.tot
      ).toFixed(2)
    );
    // isNaN(completedPercentage) ? completedPercentage = 0 : null;
  }
  // isNaN(parseFloat(completedPercentage)) ? completedPercentage = 0 : null;
  return row.value.indexOf("ERR:") != "-1" && row.original ? (
    <span>
      <span className="showtitle" id={`x${row.original._id._str}`}>
        {row.value.split("ERR:")[0]}
      </span>
      <UncontrolledTooltip
        placement="left"
        target={`x${row.original._id._str}`}
      >
        {"ERROR : " + row.value.split("ERR:")[1]}
      </UncontrolledTooltip>
    </span>
  ) : completedPercentage != 0 ? (
    <span>
      <span className="showtitle" id={`x${row.original._id._str}`}>
        {`${completedPercentage != "100.00" ? completedPercentage + "%" : ""} ${row.value
          }`}
      </span>
      {/* <UncontrolledTooltip
        placement="left"
        target={`x${row.original._id._str}`}
      >
        {`* Partially generated reports are useful when you want to check `}
      </UncontrolledTooltip> */}
    </span>
  ) : (
    <span>{row.value}</span>
  );
}
function add(allVals) {
  let total = 0;
  allVals.map(av => {
    let tot = parseFloat(String(av).replace(/,/g, ""));
    total += !isNaN(tot) ? tot : 0;
  });
  // let ret = toCurrency(total);
  return total;
}

function getUserInfo() {
  return JSON.parse(getCookie('orosession'));
}

function sentenceCase(strval) {

  let tolowcase = strval.toLowerCase()
  let n = tolowcase.split(".");
  let newname = "";
  for (let i = 0; i < n.length; i++) {
    let j = 0;
    while (j < n[i].length) {
      if (n[i].charAt(j) != " ") {
        n[i] = n[i].replace(n[i].charAt(j), n[i].charAt(j).toUpperCase());
        break;
      }
      else
        j++;
    }

    newname = newname.concat(n[i] + ".");
  }
  return newname


}

function toTitleCase(str) {
  // skip KCC, IIT-M, e-commerce etc
  if (!str) { str = ""; }
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function camelCase(strval) {
  let str = strval.toLowerCase()
  return str.replace(/\W+(.)/g, function (match, chr) {
    return chr.toUpperCase();
  });
}

function toDate(val) {
  let dateval
  if (val && typeof val == 'number') {
    dateval = moment(String(val), 'YYYYMMDD').local().format('DD/MM/YYYY')
  } else if (typeof val == 'string') {
    dateval = moment(String(val)).format('DD/MM/YYYY')
  } else {
    let dtval = parseInt(moment(new Date(val)).format("YYYYMMDD"));
    dateval = moment(String(dtval), 'YYYYMMDD').local().format('DD/MM/YYYY')
  }
  return dateval
}


const toDateTime = (val) => {
  let dateval
  if (val && typeof val == 'number') {
    dateval = moment(String(val), 'YYYYMMDD').format('DD/MM/YYYY HH:MM:SS')
  } else if (typeof val == 'string') {
    dateval = moment(String(val), 'YYYY-MM-DD').format('DD/MM/YYYY HH:MM:SS')
  } else {
    let dtval = parseInt(moment(new Date(val)).format("YYYYMMDD"));
    dateval = moment(String(dtval), 'YYYYMMDD').format('DD/MM/YYYY HH:MM:SS')
  }
  return dateval
}

function allDates(param) {
  if (param == "today") {
    return moment();
  } else if ((param == "monthstart")) {
    return moment().startOf("month");
  } else if (param.indexOf('ago')) {
    // 
  }

}

const getRequiredField = ({ shouldProceed, current }) => {
  // let lgs = this.props.liftGlobalState;
  let {
    errorMessages,
    currentPage,
    pageData,
    LocalVars,
    formElements
  } = current.props.parentState;

  currentPage = currentPage.toLowerCase();
  const formDefinition = formElements[currentPage]["form"];

  formDefinition.map(formdef => {

    if (formdef && formdef['subComponents']) {
      formdef['subComponents'].map(subformdef => {
        if (subformdef["name"] && subformdef["isRequired"] == true && (pageData[subformdef['name']] == undefined || pageData[subformdef['name']] == "")) {
          shouldProceed = false;
          let x = current.props.parentState.errorMessages;
          x[subformdef["name"]] = "X";
          current.props.liftGlobalState({ name: 'errorMessages' }, x)
        }
      })
    }
    if (formdef["name"] && formdef["isRequired"] == true && (pageData[formdef['name']] == undefined || pageData[formdef['name']] == "")) {
      shouldProceed = false;
      let x = current.props.parentState.errorMessages;
      x[formdef["name"]] = "X";
      current.props.liftGlobalState({ name: 'errorMessages' }, x)
    }
  });
}

const getBusinessControls = (fields, pageData) => {
  let allc = { basic: [], more: [], action: [], advance: [], basiccnt: 0, morecnt: 0, advancecnt: 0 };
  try {
    fields.map((field, idx) => {
      if (field.tag) {
        allc[field.tag].push(field);
      }
    });
  }
  catch (e) {

  }

  return allc;
}

export {
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  statusErrorDisplay,
  getObjectsValue,
  add,
  shouldDisplayComponent,
  currencyCommas,
  getUserInfo,
  sentenceCase,
  toTitleCase,
  camelCase,
  toDate,
  allDates,
  generateOtherValues,
  getRequiredField,
  getMomentDiff,
  removeElementFromArray,
  clearDisplayData,
  forceClearData,
  number2text,
  getCookie,
  calculateInterest,
  padding,
  RelevantIcon,
  setCookie,
  handleLogout,
  unsetAllPopovers,
  handleToggleColumn,
  toggleColumnValue,
  applyColumnStyleToReport,
  handleFilter,
  stringMaker,
  getObjectsObject,
  getBusinessControls,
  setStyleToColumns,
  groupServerData,
  toAngle,
  getReportColumns,
  checkAccessRights,
  reversibleHash,
  reverseHash,
  toggleFullReport,
  download_csv,
  download_xlsx,
  normalizeDisplayData,
  simple_csv_download,
  currencyNonCommas,
  checkIfFastpathAllowed,
  getResultFromCondition, getValueFromCondition, replaceVariablesWithValue, handleLink,
  toggleSidebar,
  usUnicode,
  startFaviconSpin,
  stopFaviconSpin,
  closeSidebar,
  openSidebar,
  goToName,
  detectBrowser,
  getDisplayedTabUID,
  getMissingFields,
  setRealCookie,
  getRealCookie
};

// let finalTaxData = {
//   Credit: { invoice: 10, tds: 110, gst: 70 },
//   Debit: { invoice: 20, tds: 50, gst: 440 }
// };
// // convert to
// let finalTaxData = [
// {type:"invoice",credit:10,debit:20},
// {type:"tds",credit:110,debit:50},
// {type:"gst",credit:70,debit:440}
// ]
